import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import moment from "moment";
import Tab from "components/common/Tab";
import { CityDropdownForTrip, CommonDateRange } from "components";
import { constant } from "constants/constant";
import { getNewGpsVehicles } from "_services";
import StorageService from "utils/StorageServices";
import Loading from "pages/Loading";
import { Images } from "constants";
import {
  getTimeLineGPSData,
  getTimeLineGPSList,
  gpsParkedList,
  gpsRunningList,
  gpsSummaryList,
} from "_services/newGpsServices";
import { utils } from "helper";
import CustomTooltip from "components/CustomTooltip/CustomTooltip";
import toast from "react-hot-toast";
import NewRunningVehicleGps from "pages/Dashboard/NewGpsTimeline/NewRunningVehicleGps";
import { StorageServices } from "utils";
import useDocumentTitle from "hooks/useDocumentTitle";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const MainDetailsGPS = (props) => {
  let { tripDetais } = props;
 useDocumentTitle("GPS | T360");
  const query = useQuery();
  const navigate = useNavigate();
  const location = useLocation();

  // Query params
  const tbn = query.get("tbn") || "0";
  const vn = query.get("vn") || "";
  const cmid = query.get("cmid") || "";

  const [isLoading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(Number(tbn));
  const companyId = StorageServices.getCompanyId();

  const [summaryData, setSummaryData] = useState([]);
  const [runingHistory, setRuningHistory] = useState([]);
  const [stoppage, setStoppage] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [selectedDateTimeRange, setSelectedDateTimeRange] = useState({
    startDate: "",
    endDate: "",
  });

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    const params = new URLSearchParams(location.search);
    params.set("tbn", tabId);
    navigate(`${location.pathname}?${params.toString()}`);
  };
  const containerRef = useRef(null);
  const offsetRef = useRef(1);
  const vehicleLoadingRef = useRef(false);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [offset, setOffset] = useState(1);
  const [vehicleLoading, setVehicleLoading] = useState(false);
  const [gpsTimeLineFetchData, setGpsTimeLineFetchData] = useState([]);
  const [mapTimeLineFetchData, setMapTimeLineFetchData] = useState([]);

  const fetchTimelineGps = async () => {
    const startDate = tripDetais?.dispatch_date
      ? moment(tripDetais?.dispatch_date).startOf("day").add(1, "minute")
      : moment(new Date());

    const endDate = tripDetais?.end_date
      ? moment(tripDetais?.end_date).endOf("day")
      : moment(new Date());

    const fromTime = tripDetais?.dispatch_date
      ? moment(tripDetais.dispatch_date).format("HH:mm")
      : moment().format("HH:mm");

    const toTime = tripDetais?.end_date
      ? moment(tripDetais.end_date).format("HH:mm")
      : moment(new Date()).format("HH:mm");

    const payload = {
      companyId: companyId,
      vehicleNo: tripDetais?.vehicle_id?.vehicle_no,
      fromDate: startDate.format("YYYY-MM-DD"),
      toDate: endDate.format("YYYY-MM-DD"),
      fromTime: fromTime,
      toTime: toTime,
    };

    try {
      setLoading(true);
      const res = await gpsRunningList(payload);
      if (res?.responseCode === 404) {
        toast.error(res?.error);
        return setRuningHistory([]);
      }
      if (res?.responseCode === 200) {
        setRuningHistory(res?.data);
      } else {
        if (res?.response?.data?.error) {
          toast.error(res?.response?.data?.error);
        }
      }
    } catch (err) {
      if (err?.response?.data?.responseCode === 400) {
        toast.error(err?.response?.data?.error);
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchSummaryGps = async () => {
    const startDate = tripDetais?.dispatch_date
      ? moment(tripDetais?.dispatch_date).startOf("day").add(1, "minute")
      : moment(new Date());

    const endDate = tripDetais?.end_date
      ? moment(tripDetais?.end_date).endOf("day")
      : moment(new Date());

    const fromTime = tripDetais?.dispatch_date
      ? moment(tripDetais.dispatch_date).format("HH:mm")
      : moment().format("HH:mm");

    const toTime = tripDetais?.end_date
      ? moment(tripDetais.end_date).format("HH:mm")
      : moment(new Date()).format("HH:mm");

    const payload = {
      companyId: companyId,
      vehicleNo: tripDetais?.vehicle_id?.vehicle_no,
      fromDate: startDate.format("YYYY-MM-DD"),
      toDate: endDate.format("YYYY-MM-DD"),
      fromTime: fromTime,
      toTime: toTime,
    };

    try {
      setLoading(true);
      const res = await gpsSummaryList(payload);
      if (res?.responseCode === 404) {
        toast.error(res?.error);
        return setSummaryData([]);
      }
      if (res?.responseCode === 200) {
        setSummaryData(res?.data);
      } else {
        if (res?.response?.data?.error) {
          toast.error(res?.response?.data?.error);
        }
      }
    } catch (err) {
      if (err?.response?.data?.responseCode === 400) {
        toast.error(err?.response?.data?.error);
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchStoppageGps = async () => {
    const startDate = tripDetais?.dispatch_date
      ? moment(tripDetais?.dispatch_date).startOf("day").add(1, "minute")
      : moment(new Date());

    const endDate = tripDetais?.end_date
      ? moment(tripDetais?.end_date).endOf("day")
      : moment(new Date());

    const fromTime = tripDetais?.dispatch_date
      ? moment(tripDetais.dispatch_date).format("HH:mm")
      : moment().format("HH:mm");

    const toTime = tripDetais?.end_date
      ? moment(tripDetais.end_date).format("HH:mm")
      : moment(new Date()).format("HH:mm");

    const payload = {
      companyId: companyId,
      vehicleNo: tripDetais?.vehicle_id?.vehicle_no,
      fromDate: startDate.format("YYYY-MM-DD"),
      toDate: endDate.format("YYYY-MM-DD"),
      fromTime: fromTime,
      toTime: toTime,
    };

    try {
      setLoading(true);
      const res = await gpsParkedList(payload);
      if (res?.responseCode === 404) {
        toast.error(res?.error);
        return setStoppage([]);
      }
      if (res?.responseCode === 200) {
        setStoppage(res?.data);
      } else {
        if (res?.response?.data?.error) {
          toast.error(res?.response?.data?.error);
        }
      }
    } catch (err) {
      if (err?.response?.data?.responseCode === 400) {
        toast.error(err?.response?.data?.error);
      }
    } finally {
      setLoading(false);
    }
  };

  const tabProps = {
    tabList: constant.newGpsTrackerTabs,
    callBackTab: handleTabChange,
    activeTab,
  };

  const handleVehicleSelect = (item) => {
    setSelectedVehicle(item);
    const params = new URLSearchParams(location.search);
    params.set("vn", item?.value);
    params.set("cmid", item?.cmid);
    navigate(`${location.pathname}?${params.toString()}`);
  };

  const handleApplyDateRange = (range) => {
    setSelectedDateTimeRange(range);
  };

  const tripNumberFunction = (array) => {
    const matchedTrip = array?.find(
      (el) => el?.trip_number === tripDetais?.trip_number
    );
    return matchedTrip?.trip_number ? (
      <div className="_separateBxs">
        {" "}
        <Link className="_trip_ind me-2">
          {" "}
          <span>Trip</span>{" "}
          <div className="trpCode"> {matchedTrip?.trip_number} </div>{" "}
        </Link>{" "}
      </div>
    ) : (
      "-"
    );
  };

  const getDateRange = (startDate, endDate) => {
    const today = moment().startOf("day");

    if (!startDate && !endDate) {
      return {
        fromDate: today.format("YYYY-MM-DD"),
        toDate: today.format("YYYY-MM-DD"),
      };
    }

    const start = moment(startDate, moment.ISO_8601, true).isValid()
      ? moment(startDate).startOf("day").add(1, "minute")
      : today;

    if (startDate && !endDate) {
      return {
        fromDate: start.format("YYYY-MM-DD"),
        toDate: start.clone().add(14, "days").format("YYYY-MM-DD"),
      };
    }

    const end = moment(endDate, moment.ISO_8601, true).isValid()
      ? moment(endDate).endOf("day")
      : today;

    const diffInDays = end.diff(start, "days");

    if (diffInDays <= 14) {
      return {
        fromDate: start.format("YYYY-MM-DD"),
        toDate: end.format("YYYY-MM-DD"),
      };
    } else {
      return {
        fromDate: start.format("YYYY-MM-DD"),
        toDate: start.clone().add(14, "days").format("YYYY-MM-DD"),
      };
    }
  };

  const fatchGpsTimeLineData = async (currentOffset) => {
    if (vehicleLoadingRef.current) return;

    vehicleLoadingRef.current = true;
    setVehicleLoading(true);

    const fromTime = tripDetais?.dispatch_date
    ? moment(tripDetais.dispatch_date).format("HH:mm")
    : moment().format("HH:mm");

    const toTime = tripDetais?.end_date
    ? moment(tripDetais.end_date).format("HH:mm")
    : moment(new Date()).format("HH:mm");

    try {
      const payload = {
        companyId: companyId,
        vehicleNo: tripDetais?.vehicle_id?.vehicle_no,
        fromTime: fromTime,
        toTime: toTime,
        ...getDateRange(tripDetais?.dispatch_date, tripDetais?.end_date),
      };

      const query = {
        limit: 20,
        offset: currentOffset,
      };

      const res = await getTimeLineGPSList(payload, query);

      if (res?.responseCode === 200) {
        const gps_Data = res?.data?.timeline || [];
        const gps_map_Data = res?.data?.completeTimeline || [];
        const totalRecord = res?.totalResults || 0;

        const newData =
          currentOffset === 1
            ? gps_Data
            : [...gpsTimeLineFetchData, ...gps_Data];
        const mapData =
          currentOffset === 1
            ? gps_map_Data
            : [...mapTimeLineFetchData, ...gps_map_Data];

        setGpsTimeLineFetchData(newData);
        setMapTimeLineFetchData(mapData);

        if (newData.length >= totalRecord || !res?.hasMore) {
          setHasMoreData(false);
        } else {
          setHasMoreData(true);
          const nextOffset = currentOffset + 1;
          setOffset(nextOffset);
          offsetRef.current = nextOffset;
        }
      } else {
        if (res?.error) {
          toast.error(res?.error);
        }
      }
    } catch (err) {
      if (err?.response?.data?.responseCode === 400) {
        toast.error(err?.response?.data?.error);
      }
      setHasMoreData(false);
    } finally {
      vehicleLoadingRef.current = false;
      setVehicleLoading(false);
    }
  };

  const handleScroll = () => {
    const el = containerRef.current;
    if (!el || vehicleLoadingRef.current || !hasMoreData) return;

    const threshold = 200;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - threshold) {
      fatchGpsTimeLineData(offsetRef.current);
    }
  };

  const fetchInitialData = () => {
    if (!vehicleLoadingRef.current) {
      fatchGpsTimeLineData(1);
    }
  };

  useEffect(() => {
    if (activeTab === 0) {
      fetchSummaryGps();
    }
    if (activeTab === 1) {
      fetchTimelineGps();
    }
    // if (vn && activeTab === 2) {
    if (activeTab === 2) {
      setOffset(1);
      offsetRef.current = 1;
      setGpsTimeLineFetchData([]);
      setMapTimeLineFetchData([]);
      setHasMoreData(true);
      fetchInitialData();
    }
    if (activeTab === 3) {
      fetchStoppageGps();
    }
    // }, [cmid, vn, selectedDateTimeRange.startDate, selectedDateTimeRange.endDate, activeTab]);
  }, [tripDetais, activeTab]);

  const fetchFromCity = async (search, page, limit) => {
    const res = await getNewGpsVehicles({
      companyId: StorageService.getCompanyId(),
      page: page,
      limit,
      search,
    });
    if (res?.responseCode === 200) {
      const list = res?.data?.map((c) => ({
        ...c,
        value: c.vehicle_no,
        label: c.vehicle_no,
        _id: c.id,
      }));
      return {
        items: [...list],
        total: res?.totalResults,
      };
    } else {
      toast.error(res?.responseMessage);
    }
  };

  return (
    <div className="__mainGps_bx">
      <div className="addPr_flBx">
        <div
          className="_secFilts_gps"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Tab {...tabProps} />
          <div className="llt_dash_branch_date __dateTime_nw">
            <span style={{ opacity: "0.7" }}>
              From Date:{" "}
              {tripDetais?.dispatch_date &&
                `${utils.formatDateMonth(
                  tripDetais?.dispatch_date
                )} ${utils.formatAMPM(tripDetais?.dispatch_date)}`}
            </span>
            {tripDetais?.end_date && (
              <span style={{ opacity: "0.7" }}>
                To Date:{" "}
                {tripDetais?.end_date &&
                  `${utils.formatDateMonth(
                    tripDetais?.end_date
                  )} ${utils.formatAMPM(tripDetais?.end_date)}`}
              </span>
            )}
          </div>
        </div>

        {activeTab == 0 && (
          <div className="__gpsSummary_bx">
            <div className="__gpsSummary_inr __gpsSummary_runningTab">
              <div className="__gpsSummary_item">
                <table>
                  <thead>
                    <tr>
                      <td>
                        <div className="__txt_sphire">Vehicle</div>
                      </td>
                      <td>
                        <div className="__txt_sphire">Vehicle Avg</div>
                      </td>
                      <td>
                        <div className="__txt_sphire">Running KM</div>
                      </td>
                      <td>
                        <div className="__txt_sphire">Idle KM </div>
                      </td>
                      <td>
                        <div className="__txt_sphire">Running Time</div>
                      </td>
                      <td>
                        <div className="__txt_sphire">Stopped Duration</div>
                      </td>
                      <td>
                        <div className="__txt_sphire">Ideal Duration</div>
                      </td>
                      <td>
                        <div className="__txt_sphire">GPS Fuel Consumed</div>
                      </td>
                      <td>
                        <div className="__txt_sphire">GPS Inactive</div>
                      </td>
                      <td>
                        <div className="__txt_sphire">Unreachable Duration</div>
                      </td>
                      <td>
                        <div className="__txt_sphire">Alerts</div>
                      </td>
                    </tr>
                  </thead>

                  <tbody>
                    {summaryData?.map((el, ind) => {
                      return (
                        <tr key={ind}>
                          <td>
                            <div className="__txt_sphire">
                              {el?.status === "empty"
                                ? "Empty Running"
                                : el?.status === "loaded"
                                ? "Trip Running"
                                : utils.firstLetterCapital(el?.status)}
                            </div>
                          </td>
                          <td>
                            <div className="__txt_sphire"> - </div>
                          </td>
                          <td>
                            <div className="__perCent_bxx">
                              <div className="__txt_sphire">
                                {" "}
                                {(
                                  el?.total_idle_distance_km +
                                  el?.total_running_distance_km
                                )?.toFixed(2)}{" "}
                              </div>
                              <span
                                style={{
                                  backgroundColor: "rgba(242, 255, 239, 1)",
                                }}
                              ></span>
                            </div>
                          </td>
                          <td>
                            <div className="__txt_sphire">
                              {" "}
                              {el?.total_idle_distance_km}{" "}
                            </div>
                          </td>
                          <td>
                            <div className="__txt_sphire">
                              {" "}
                              {el?.total_running_time}{" "}
                            </div>
                          </td>
                          <td>
                            <div className="__txt_sphire">
                              {el?.total_parked_time}
                            </div>
                          </td>
                          <td>
                            <div className="__txt_sphire">
                              {el?.total_idle_time}
                            </div>
                          </td>
                          <td>
                            <div className="__txt_sphire"> - </div>
                          </td>
                          <td>
                            <div className="__txt_sphire"> - </div>
                          </td>
                          <td>
                            <div className="__perCent_bxx">
                              <div className="__txt_sphire">
                                {el?.total_unreachable_time}
                              </div>
                              <span
                                style={{
                                  backgroundColor: "rgba(242, 255, 239, 1)",
                                }}
                              ></span>
                            </div>
                          </td>
                          <td>
                            <div className="__txt_sphire"> - </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {activeTab == 1 && (
          <div className="__fltTier_tableBx">
            <table>
              <thead>
                <tr>
                  <th>Vehicle</th>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th>Start Location</th>
                  <th>End Location</th>
                  <th>Distance</th>
                  <th>Duration</th>
                  <th>Avarage Speed</th>
                  <th> Progress </th>
                  <th> Status </th>
                  <th>Running Status</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan={10}>
                      <div
                        className="__fltHist_txs"
                        style={{ textAlign: "center" }}
                      >
                        Loading...
                      </div>
                    </td>
                  </tr>
                ) : runingHistory.length > 0 ? (
                  runingHistory.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <div className="__fltHist_txs">
                            {item?.vehicle_no}
                          </div>
                        </td>
                        <td>
                          <div className="__fltHist_txs">
                            {item?.fromDate
                              ? moment(item?.fromDate).format("DD MMM yyyy")
                              : "-"}
                          </div>
                          <div className="__fltHist_txs">{item?.fromTime}</div>
                        </td>
                        <td>
                          <div className="__fltHist_txs">
                            {item?.toDate
                              ? moment(item?.toDate).format("DD MMM yyyy")
                              : "-"}
                          </div>
                          <div className="__fltHist_txs">{item?.toTime}</div>
                        </td>
                        <td>
                          <div className="__fltHist_txs">
                            {(() => {
                              const name = item?.startLocation || "";
                              const value = String(name);

                              return value.length > 20 ? (
                                <CustomTooltip
                                  txtClass="__tooltipTxt_bx"
                                  cstStyle={{ maxWidth: "138px" }}
                                >
                                  <p>{value}</p>
                                </CustomTooltip>
                              ) : (
                                <div className="__NottooltipTxt">
                                  <p>{value ? value : "-"}</p>
                                </div>
                              );
                            })()}
                          </div>
                        </td>
                        <td>
                          <div className="__fltHist_txs">
                            {(() => {
                              const name = item?.endLocation || "";
                              const value = String(name);

                              return value.length > 20 ? (
                                <CustomTooltip
                                  txtClass="__tooltipTxt_bx"
                                  cstStyle={{ maxWidth: "138px" }}
                                >
                                  <p>{value}</p>
                                </CustomTooltip>
                              ) : (
                                <div className="__NottooltipTxt">
                                  <p>{value ? value : "-"}</p>
                                </div>
                              );
                            })()}
                          </div>
                        </td>
                        <td>
                          <div className="__fltHist_txs">
                            {item?.distance
                              ? `${Math.floor(item?.distance * 1000) / 1000} KM`
                              : "-"}
                          </div>
                        </td>
                        <td>
                          <div className="__fltHist_txs">
                            {item?.duration ? item?.duration : "-"}
                          </div>
                        </td>
                        <td>
                          <div className="__fltHist_txs">
                            {" "}
                            {item?.average_speed
                              ? `${item?.average_speed} km/h`
                              : "-"}{" "}
                          </div>
                        </td>
                        <td>
                          {item?.inProgress ? (
                            <span className="_lrBillRaised_status">
                              In Progress
                            </span>
                          ) : (
                            <span className="_lrDelivered_status">
                              Completed
                            </span>
                          )}
                        </td>
                        <td>
                          {item?.trips?.length > 0 ? (
                            <>{tripNumberFunction(item?.trips)}</>
                          ) : (
                            "-"
                          )}
                        </td>

                        <td>
                          <div className="__empty_txs">{item?.status}</div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={10} style={{ textAlign: "center" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                        }}
                      >
                        <img src={Images.NoRecordFound} alt="" />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {activeTab === 2 && (
          <div className="__fltTierBx">
            <div className="__flxTierDx">
              <div
                className="__gpsTimeLine_bx"
                ref={containerRef}
                onScroll={handleScroll}
              >
                {isLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Loading />
                  </div>
                ) : gpsTimeLineFetchData.length > 0 ? (
                  gpsTimeLineFetchData.map((item, index) => {
                    return (
                      <div className="__fltsFlects_main" key={index}>
                        <div className="__fltsFlects_time">
                          <div>
                            <h4>
                              {item?.fromDate
                                ? moment(item?.fromDate, "YYYY-MM-DD").format(
                                    "DD MMM YYYY"
                                  )
                                : "-"}
                            </h4>
                            <p>{item?.fromTime}</p>
                          </div>

                          <div>
                            <h4>
                              {item?.toDate
                                ? moment(item?.toDate, "YYYY-MM-DD").format(
                                    "DD MMM YYYY"
                                  )
                                : "-"}
                            </h4>
                            <p>{item?.toTime ? item?.toTime : "-"}</p>
                          </div>
                        </div>
                        <div
                          className={`__fltsFlects_detail`}
                          style={{
                            color:
                              item.status === "Running"
                                ? "#00c853"
                                : item.status === "Idle"
                                ? "#d3d32dff"
                                : item.status === "Parked"
                                ? "#d50000"
                                : "#d50000",
                          }}
                        >
                          <span className="__verLine_flt"></span>

                          <div className="__fltsDetail_inr">
                            <h4>{item.status}</h4>
                            <div className="gps_tracker_s">
                              {item.status === "Running" ? (
                                item?.distance ? (
                                  <ul>
                                    <li>{`${
                                      Math.floor(item?.distance * 1000) / 1000
                                    } KM`}</li>
                                  </ul>
                                ) : (
                                  ""
                                )
                              ) : (
                                ""
                              )}
                              {item?.duration ? (
                                <ul>
                                  <li>{item?.duration}</li>
                                </ul>
                              ) : (
                                ""
                              )}
                            </div>
                            <p>
                              {item?.startLocation ? item?.startLocation : ""}
                            </p>
                            <p>{item?.endLocation ? item?.endLocation : ""}</p>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : vehicleLoading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <Loading />
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <img src={Images.NoRecordFound} alt="" />
                  </div>
                )}
              </div>

              <NewRunningVehicleGps timeline={mapTimeLineFetchData} />
            </div>
          </div>
        )}

        {activeTab == 3 && (
          <div className="__fltTier_tableBx">
            <table>
              <thead>
                <tr>
                  <th>Vehicle</th>
                  <th>Stop Time</th>
                  <th>Start Time</th>
                  <th>Location</th>
                  <th>Nearest Location</th>
                  <th>After Distance</th>
                  <th>Duration</th>
                  <th>Avarage Speed</th>
                  <th> Progress </th>
                  <th> Status </th>
                  <th>Running Status</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan={10}>
                      <div
                        className="__fltHist_txs"
                        style={{ textAlign: "center" }}
                      >
                        Loading...
                      </div>
                    </td>
                  </tr>
                ) : stoppage.length > 0 ? (
                  stoppage.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          <div className="__fltHist_txs">
                            {item?.vehicle_no ? item?.vehicle_no : "-"}
                          </div>
                        </td>
                        <td>
                          <div className="__fltHist_txs">
                            {item?.fromDate
                              ? moment(item?.fromDate).format("DD MMM yyyy")
                              : "-"}
                          </div>
                          <div className="__fltHist_txs">{item?.fromTime}</div>
                        </td>
                        <td>
                          <div className="__fltHist_txs">
                            {item?.toDate
                              ? moment(item?.toDate).format("DD MMM yyyy")
                              : "-"}
                          </div>
                          <div className="__fltHist_txs">{item?.toTime}</div>
                        </td>
                        <td>
                          <div className="__fltHist_txs">
                            {(() => {
                              const name = item?.startLocation || "";
                              const value = String(name);

                              return value.length > 20 ? (
                                <CustomTooltip
                                  txtClass="__tooltipTxt_bx"
                                  cstStyle={{ maxWidth: "138px" }}
                                >
                                  <p>{value}</p>
                                </CustomTooltip>
                              ) : (
                                <div className="__NottooltipTxt">
                                  <p>{value ? value : "-"}</p>
                                </div>
                              );
                            })()}
                          </div>
                        </td>
                        <td>
                          <div className="__fltHist_txs">
                            {(() => {
                              const name = item?.endLocation || "";
                              const value = String(name);

                              return value.length > 20 ? (
                                <CustomTooltip
                                  txtClass="__tooltipTxt_bx"
                                  cstStyle={{ maxWidth: "138px" }}
                                >
                                  <p>{value}</p>
                                </CustomTooltip>
                              ) : (
                                <div className="__NottooltipTxt">
                                  <p>{value ? value : "-"}</p>
                                </div>
                              );
                            })()}
                          </div>
                        </td>
                        <td>
                          <div className="__fltHist_txs">
                            {item?.distance
                              ? `${Math.floor(item?.distance * 1000) / 1000} KM`
                              : "-"}
                          </div>
                        </td>
                        <td>
                          <div className="__fltHist_txs">
                            {item?.duration ? item?.duration : "-"}
                          </div>
                        </td>
                        <td>
                          <div className="__fltHist_txs">
                            {" "}
                            {item?.average_speed
                              ? `${item?.average_speed} km/h`
                              : "-"}{" "}
                          </div>
                        </td>
                        <td>
                          {item?.inProgress ? (
                            <span className="_lrBillRaised_status">
                              In Progress
                            </span>
                          ) : (
                            <span className="_lrDelivered_status">
                              Completed
                            </span>
                          )}
                        </td>
                        <td>
                          {item?.trips?.length > 0 ? (
                            <>{tripNumberFunction(item?.trips)}</>
                          ) : (
                            "-"
                          )}
                        </td>
                        <td>
                          <div className="__empty_txs">{item?.status}</div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={10} style={{ textAlign: "center" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "100%",
                        }}
                      >
                        <img src={Images.NoRecordFound} alt="" />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default MainDetailsGPS;
